import React from 'react'
import { Table, Placeholder, Segment } from 'semantic-ui-react'

// Default to 5 rows and 3 columns if not specified
const SkeletonTable = ({ rows = 5, columns = 3 }) => {
  const renderPlaceholderRow = key => (
    <Table.Row key={key}>
      {Array.from({ length: columns }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Table.Cell key={index}>
          <Placeholder>
            <Placeholder.Line />
          </Placeholder>
        </Table.Cell>
      ))}
    </Table.Row>
  )

  return (
    <Segment>
      <Table celled>
        <Table.Header>
          <Table.Row>
            {Array.from({ length: columns }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.HeaderCell key={index}>
                <Placeholder>
                  <Placeholder.Line />
                </Placeholder>
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {Array.from({ length: rows }).map((_, index) => renderPlaceholderRow(index))}
        </Table.Body>
      </Table>
    </Segment>
  )
}

export default SkeletonTable
